<template>
  <div>
    <div class="member-mobile-nav">
      <div class="title">
        <div>會員帳號</div>
      </div>
      <div class="link">
        <router-link to="/gold/member_mobile/member_form">個人資料</router-link>
        <router-link to="/gold/member_mobile/member_order">訂單</router-link>
        <router-link v-if="isSpecialMember === 1" to="/gold/member_mobile/contracted_store_form">特約廠商資料</router-link>
      </div>
      <button class="btn-special-member" v-if="isSpecialMember === null || isSpecialMember === 0"><router-link to="/gold/member_mobile/contracted_store_form">成為特約廠商</router-link></button>
      <button v-on:click="loginOut">登出</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "memberMobileNav",
  methods: {
    loginOut() {
      this.$store.dispatch("loginOut");
      this.$router.push("/gold/member_login");
    }
  },
  computed: {
    isSpecialMember() {
      return this.$store.getters.getSpecialMemberState;
    }
  }
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}
.member-mobile-nav > * {
  font-weight: 600;
  line-height: 40px;
}
.member-mobile-nav {
  height: 100%;
  padding: 24.5px 31px;
  color: $primaryDeepColor;
  background-color: rgba($primaryLightColor, 0.25);
  .btn-special-member {
    margin-bottom: 15px;
  }
}
.title {
  font-size: 24px;
  padding: 4px 0;
  border-top: 3px solid $primaryDeepColor;
  border-bottom: 3px solid $primaryDeepColor;
}
.title::before,
.title::after {
  content: "";
  display: block;
  width: 100%;
  height: 1px;
  background-color: $primaryDeepColor;
}
.link {
  padding-top: 18.5px;
  padding-bottom: 30px;
}
.link > * {
  border-top: 1px solid $primaryDeepColor;
  border-bottom: 1px solid $primaryDeepColor;
}
.link > *:nth-child(2n) {
  border-top: 0;
}
a,
button {
  display: block;
  font-size: 17px;
  color: $primaryDeepColor;
}
a:hover,
button:hover {
  color: $secondaryColor3;
  background-color: $primaryDeepColor;
}
button {
  width: 100%;
  border: 1px solid $primaryDeepColor;
  background-color: rgba(0, 0, 0, 0);
}
</style>
